import { render, staticRenderFns } from "./VHeader.vue?vue&type=template&id=a815f342"
import script from "./VHeader.vue?vue&type=script&lang=js"
export * from "./VHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a815f342')) {
      api.createRecord('a815f342', component.options)
    } else {
      api.reload('a815f342', component.options)
    }
    module.hot.accept("./VHeader.vue?vue&type=template&id=a815f342", function () {
      api.rerender('a815f342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/pos/pos/components/complements/VHeader.vue"
export default component.exports